import { useDispatch } from 'react-redux';
import { onSubscribe } from 'store/app/app-slice';

const useAction = () => {
	const dispatch = useDispatch();

	const handler = (payload) => {
		dispatch(onSubscribe(payload));
	};

	return [handler];
};

export default useAction;
